export default {
    namespaced: true,
    state: {
        item: {
            vehicle: {},
            driver: {
                ignoreExperience: false
            },
            option: {
                depreciation: { value: 1, k: 1 },
                overnightStorage: { value: 2, k: 1.10 },
                alarm: { value: 2, k: 0.95 },
                sto: { value: 2, k: 1 },
                vehicleAge: { value: 2, k: 1 },
                franchise: { value: 2, k: 1 },
                drivingExperience: { value: 1, k: 0.9 },
                driverCount: { value: 1, k: 1 },
                cityRegistration: { value: 1, k: 1.10 },
                militaryRisk: { value: 1, k: 1 },
                vehiclePurpose: { value: 1, k: 1 },
                procedurePayment: { value: 1, k: 1 },
            },

            /* 
            <!-- Нічне зберігання (overnightStorage)
                Захищене (гараж, паркінг, охорона)	    0,85 – 0,95	Знижка 5% – 15%
                Без обмежень (вулиця, двір уночі)	    1,10 – 1,25	Надбавка 10% – 25% -->

            <!-- Сигналізація (alarm)
                Супутникова (з диспетчером)				0,80 – 0,90	Знижка 10% – 20%
                Звичайна двостороння					0,95 – 1,00	Базовий тариф (0% – 5%)
                Без сигналізації взагалі				1,10 – 1,25	Надбавка 10% – 25% -->

            <!-- Тип СТО (sto)
                Офіційний дилер (гарантійне СТО)		1,15 – 1,35	Надбавка 15% – 35%
                За вибором страхової компанії			1	Базовий тариф (0%)
                Калькуляція (виплата грошима на руки)	0,80 – 0,90	Знижка 10% – 20% -->

            <!-- Вік автомобіля  (vehicleAge)
                Новий (до 1 року)						0,90 – 1,00	Знижка до 10% або базовий тариф
                Від 1 до 3 років						1	Базовий тариф (0%)
                Старше 5–7 років						1,05 – 1,20	Надбавка 5% – 20% -->

            <!-- Франшиза (franchise)
                Пошкодження 0% (без франшизи)			1,20 – 1,40	Надбавка 20% – 40%
                Пошкодження 0,5% (стандарт)				1	Базовий тариф (0%)
                Пошкодження 1% – 2% (велика франшиза)	0,75 – 0,85	Знижка 15% – 25% -->

            <!-- Водійський стаж (drivingExperience)
                Досвідчений водій (стаж понад 5 років)	0,90 – 1,00	Знижка до 10% або базовий тариф
                Молодий водій (стаж до 2 років)			1,20 – 1,50	Надбавка 20% – 50% -->

            <!-- Кількість водіїв (driverCount)
                Обмежена кількість (1–2 особи)			1	Базовий тариф (0%)
                Будь-який водій на законних підставах	1,10 – 1,20	Надбавка 10% – 20% -->

            <!-- Місто реєстрації (cityRegistration)
                Мегаполіси (Київ, Одеса, Львів тощо)	1,10 – 1,25	Надбавка 10% – 25%
                Невеликі міста та райцентри				0,90 – 1,00	Знижка до 10% або базовий тариф -->

            <!-- Воєнні ризики (militaryRisk)
                Без покриття воєнних ризиків			1	Базовий тариф (0%)
                З покриттям уламків ракет / БПЛА		1,15 – 1,50	Надбавка 15% – 50% -->

            <!-- Призначення авто (vehiclePurpose)
                Особисте використання					1	Базовий тариф (0%)
                Таксі, прокат, оренда, доставка			1,50 – 2,50	Надбавка 50% – 150% -->

            <!-- Порядок оплати (procedurePayment)
                Одноразовий платіж (100%)				1	Базовий тариф (0%)
                Розбивка на 4 платежі (щоквартально)	1,03 – 1,07	Надбавка 3% – 7% --> */
        },
    },
}

/* 
<!-- Нічне зберігання (overnightStorage)
    Захищене (гараж, паркінг, охорона)	    0,85 – 0,95	Знижка 5% – 15%
    Без обмежень (вулиця, двір уночі)	    1,10 – 1,25	Надбавка 10% – 25% -->

<!-- Сигналізація (alarm)
    Супутникова (з диспетчером)				0,80 – 0,90	Знижка 10% – 20%
    Звичайна двостороння					0,95 – 1,00	Базовий тариф (0% – 5%)
    Без сигналізації взагалі				1,10 – 1,25	Надбавка 10% – 25% -->

<!-- Тип СТО (sto)
    Офіційний дилер (гарантійне СТО)		1,15 – 1,35	Надбавка 15% – 35%
    За вибором страхової компанії			1	Базовий тариф (0%)
    Калькуляція (виплата грошима на руки)	0,80 – 0,90	Знижка 10% – 20% -->

<!-- Вік автомобіля  (vehicleAge)
    Новий (до 1 року)						0,90 – 1,00	Знижка до 10% або базовий тариф
    Від 1 до 3 років						1	Базовий тариф (0%)
    Старше 5–7 років						1,05 – 1,20	Надбавка 5% – 20% -->

<!-- Франшиза (franchise)
    Пошкодження 0% (без франшизи)			1,20 – 1,40	Надбавка 20% – 40%
    Пошкодження 0,5% (стандарт)				1	Базовий тариф (0%)
    Пошкодження 1% – 2% (велика франшиза)	0,75 – 0,85	Знижка 15% – 25% -->

<!-- Водійський стаж (drivingExperience)
    Досвідчений водій (стаж понад 5 років)	0,90 – 1,00	Знижка до 10% або базовий тариф
    Молодий водій (стаж до 2 років)			1,20 – 1,50	Надбавка 20% – 50% -->

<!-- Кількість водіїв (driverCount)
    Обмежена кількість (1–2 особи)			1	Базовий тариф (0%)
    Будь-який водій на законних підставах	1,10 – 1,20	Надбавка 10% – 20% -->

<!-- Місто реєстрації (cityRegistration)
    Мегаполіси (Київ, Одеса, Львів тощо)	1,10 – 1,25	Надбавка 10% – 25%
    Невеликі міста та райцентри				0,90 – 1,00	Знижка до 10% або базовий тариф -->

<!-- Воєнні ризики (militaryRisk)
    Без покриття воєнних ризиків			1	Базовий тариф (0%)
    З покриттям уламків ракет / БПЛА		1,15 – 1,50	Надбавка 15% – 50% -->

<!-- Призначення авто (vehiclePurpose)
    Особисте використання					1	Базовий тариф (0%)
    Таксі, прокат, оренда, доставка			1,50 – 2,50	Надбавка 50% – 150% -->

<!-- Порядок оплати (procedurePayment)
    Одноразовий платіж (100%)				1	Базовий тариф (0%)
    Розбивка на 4 платежі (щоквартально)	1,03 – 1,07	Надбавка 3% – 7% --> */